import React from 'react';
import Hero from '../components/home/Hero';
import PreorderBanner from '../components/home/PreorderBanner';
import ProductSection from '../components/home/ProductSection';
import Process from '../components/home/Process';
import PartyBundleCTA from '../components/home/PartyBundleCTA';
import Reviews from '../components/home/Reviews';
import FAQSection from '../components/home/FAQ';
import Newsletter from '../components/home/Newsletter';

const Home = () => {
  return (
    <main className="bg-frost-vanilla">
      <PreorderBanner />
      <Hero />
      <Process />
      <ProductSection />
      <PartyBundleCTA />
      <Reviews />
      <FAQSection />
      <Newsletter />
    </main>
  );
};

export default Home;